/**
 * 약관 관리 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class TermsService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 약관 전체 조회
     * 약관 전체를 조회합니다.
     * @returns 약관 전체 조회 결과
     */
    getAllTermsGroupedByTermsName() {
        return this.axios.get(`/main/v1/terms`);
    }
    /**
     * 약관 목록 조회
     * 약관 목록을 조회합니다.
     * @returns 약관 목록 조회 결과
     */
    getAllTermsNames() {
        return this.axios.get(`/main/v1/terms/names`);
    }
    /**
     * 약관 상세 조회
     * 약관 내용을 조회합니다.
     * @param termsName - termsName
     * @returns 약관 상세 조회 결과
     */
    getTermsByTermsName(termsName) {
        return this.axios.get(`/main/v1/terms/name/${termsName}`);
    }
}
//# sourceMappingURL=terms.service.js.map